import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { EIPAutoCompleteComponent } from "eipauto-complete";
import { CommonService } from "src/app/Service/Common.service";
import { DocumentViewerService } from "src/app/Service/documentviewer/documentviewer.service";
import { NotificationService } from "src/app/Service/notification.service";
import { IFileUrnModel } from "src/app/ViewModel/FileUrn.Model";
import { ForgeViewerComponent } from "../forge-viewer/forge-viewer.component";

@Component({
    selector: 'app-file-compare',
    templateUrl: './file-compare.component.html',
})
export class FileCompareComponent implements OnInit {
    allDataSource: IFileUrnModel[] = [];
    dataSource: IFileUrnModel[] = [];
    projectId!: number;
    groupId!: number;
    sourceFile!: IFileUrnModel;
    destinationFile!: IFileUrnModel;
    selectedDestinationDoc!: number;
    sourceFileGrid: IFileUrnModel[] = [];
    destinationFileGrid: IFileUrnModel[] = [];
    sourceUrnModel: IFileUrnModel | null=null;
    destinationUrnModel: IFileUrnModel | null=null;
    selectableSettings = {
        checkboxOnly: true,
        mode: "single"
    };
    @ViewChild('destinationDoc') destinationDoc!: EIPAutoCompleteComponent;
    @ViewChild('sourceGrid') sourceGrid: any;
    @ViewChild('destinationGrid') destinationGrid: any;
    ngOnInit(): void {
        this.projectId = this._commonService.getProjectId();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.loadCompareDocuments();
    }

    constructor(private dialog: MatDialog, private _commonService: CommonService, private _notificationService: NotificationService, private _docViewerService: DocumentViewerService,
        public dialogRef: MatDialogRef<FileCompareComponent>) {
    }

    loadCompareDocuments() {
        this._docViewerService.GetCompareDocuments({ project_Id: this.projectId, group_Id: this.groupId }).subscribe((res: IFileUrnModel[]) => {
            this.allDataSource = res.map(x => {
                x.docTitle = x.docNo + '-' + x.title;
                return x;
            });
            this.dataSource = this.allDataSource.filter(
                (doc, i, arr) => arr.findIndex(t => t.docId === doc.docId) === i
            );
        })
    }

    onselectedValueChange(val: any, isSource: boolean) {
        if (isSource) {
            this.sourceFile = val.additionalValues.additionalValues;
            this.sourceFileGrid = this.allDataSource.filter(x => x.docId == this.sourceFile.docId);
            this.sourceUrnModel = null;
            this.selectedDestinationDoc = this.sourceFile.docId;
            //Reset the selection data changes
            this.sourceGrid.defaultSelection.selectedKeys = [];
        }
        else {
            this.destinationFile = val.additionalValues.additionalValues;
            this.destinationFileGrid = this.allDataSource.filter(x => x.docId == this.destinationFile.docId);
            this.destinationUrnModel = null;
            //Reset the selection data changes
            this.destinationGrid.defaultSelection.selectedKeys = [];
        }
    }

    onSelectionChange(event: any, isSource: boolean): void {
        if (event['selectedRows'].length > 0) {
            let selectedModel: IFileUrnModel = event['selectedRows'][0].dataItem;
            if (isSource)
                this.sourceUrnModel = selectedModel;
            else
                this.destinationUrnModel = selectedModel;
        }
        else{
            if(isSource)
                this.sourceUrnModel = null;
            else
                this.destinationUrnModel = null;
        }
    }

    isCompareEnable(): boolean {
        return !!this.sourceUrnModel && !!this.destinationUrnModel;
    }

    compareDrawings() {
        let dialogRef = this.dialog.open(ForgeViewerComponent, {
            panelClass: 'mat-dialog-primary',
            data: { sourceUrn: this.sourceUrnModel, destinationUrn: this.destinationUrnModel }
        });
    }

    public togglePopupDialog() {
        this.dataSource = [];
        this.dialogRef.close();
    }

}